export default __webpack_public_path__ + "static/media/eyes.8099480cd3cadcc0df4cc734864f5564.png";